import { Controller } from "@hotwired/stimulus"

const MONTH_DATASET_KEYS = {
  "this-month": "thisMonth",
  "next-month": "nextMonth",
  "third-month": "thirdMonth"
}

// A projection breakdown holds all three forecast months, but only the one the user
// clicked is shown. Picking a month reveals its column (CSS, via a class on the modal),
// orders the deals by it, and hides the deals that carry no weight in it.
export default class extends Controller {
  static targets = ["body", "row", "title", "empty"]
  static values = { labels: Object }

  connect() {
    this.showListener = (event) => this.show(event.relatedTarget?.dataset?.month)
    this.element.addEventListener("show.bs.modal", this.showListener)
  }

  disconnect() {
    this.element.removeEventListener("show.bs.modal", this.showListener)
  }

  show(month) {
    const slug = MONTH_DATASET_KEYS[month] ? month : "this-month"
    const key = MONTH_DATASET_KEYS[slug]

    Object.keys(MONTH_DATASET_KEYS).forEach((candidate) => {
      this.element.classList.toggle(`show-${candidate}`, candidate === slug)
    })

    if (this.hasTitleTarget) {
      this.titleTarget.textContent = this.labelsValue[slug] || ""
    }

    const sorted = [...this.rowTargets].sort(
      (a, b) => Number(b.dataset[key] || 0) - Number(a.dataset[key] || 0)
    )

    let shown = 0
    sorted.forEach((row) => {
      // Anything that rounds to 0.0% in this month is not contributing to it.
      const contributing = Number(row.dataset[key] || 0) >= 0.0005
      row.classList.toggle("d-none", !contributing)
      if (contributing) shown += 1
      this.bodyTarget.appendChild(row)
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("d-none", shown > 0)
      this.bodyTarget.appendChild(this.emptyTarget)
    }
  }
}
